var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 5.5C20.9462 5.5 5.5 20.9462 5.5 40C5.5 59.0538 20.9462 74.5 40 74.5C59.0538 74.5 74.5 59.0538 74.5 40C74.5 20.9462 59.0538 5.5 40 5.5ZM0.5 40C0.5 18.1848 18.1848 0.5 40 0.5C61.8152 0.5 79.5 18.1848 79.5 40C79.5 61.8152 61.8152 79.5 40 79.5C18.1848 79.5 0.5 61.8152 0.5 40Z",
    fill: "#00A3A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1663 14.6658C30.9298 21.0312 29.5 29.988 29.5 40C29.5 50.012 30.9298 58.9688 33.1663 65.3342C34.2885 68.5284 35.5673 70.9352 36.8629 72.4949C38.171 74.0696 39.2434 74.5 40 74.5C40.7566 74.5 41.829 74.0696 43.1371 72.4949C44.4327 70.9352 45.7115 68.5284 46.8337 65.3342C49.0702 58.9688 50.5 50.012 50.5 40C50.5 29.988 49.0702 21.0312 46.8337 14.6658C45.7115 11.4716 44.4327 9.06479 43.1371 7.5051C41.829 5.93037 40.7566 5.5 40 5.5C39.2434 5.5 38.171 5.93037 36.8629 7.5051C35.5673 9.06479 34.2885 11.4716 33.1663 14.6658ZM33.0168 4.31019C34.8192 2.14031 37.1668 0.5 40 0.5C42.8332 0.5 45.1808 2.14031 46.9832 4.31019C48.7982 6.49511 50.3208 9.50677 51.551 13.0083C54.0196 20.0343 55.5 29.5774 55.5 40C55.5 50.4226 54.0196 59.9657 51.551 66.9917C50.3208 70.4932 48.7982 73.5049 46.9832 75.6898C45.1808 77.8597 42.8332 79.5 40 79.5C37.1668 79.5 34.8192 77.8597 33.0168 75.6898C31.2018 73.5049 29.6792 70.4932 28.449 66.9917C25.9804 59.9657 24.5 50.4226 24.5 40C24.5 29.5774 25.9804 20.0343 28.449 13.0083C29.6792 9.50677 31.2018 6.49511 33.0168 4.31019Z",
    fill: "#00A3A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 42.5H3V37.5H77V42.5Z",
    fill: "#00A3A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternet);
export default __webpack_public_path__ + "static/media/Internet.c23e7a3cf06d75262f317a388fa96c6c.svg";
export { ForwardRef as ReactComponent };